import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './RePostPayment.module.css';
import PopupHeader from '../../../../components/PopupHeader';
import Button from '../../../../components/Button';
import strings from '../../../../globalization';
import { TicketStatusType } from '../../../../enums';
import FireboardUtils from '../../../../util/fireboard-util';

const RePostPayment = props => {
  const { selectedItem, currency, onClose, iso2, rePostPayment } = props;
  const { tickets } = selectedItem || {};
  const filteredTickets = tickets && tickets.length ? tickets.filter(t => t.paymentStatus && t.paymentStatus.toLowerCase() !== 'hidden') : [];
  const [checkInfo, setCheckInfo] = useState({
    isTextToPay: false,
    phoneNumber: '',
    guestName: '',
    pickupDate: '',
  });

  const getTotal = ticket => (+ticket.ticketAmount - +ticket.tipAmount).toFixed(2);

  const getTip = ticket => (+ticket.tipAmount).toFixed(2);

  const getAmount = ticket => (+ticket.ticketAmount).toFixed(2);

  useEffect(() => {
    const isTextToPay = FireboardUtils.isTextTPay(selectedItem?.sourceType);
    const phnNumber = FireboardUtils.getPhoneNumber(selectedItem);
    const phoneNumber = FireboardUtils.formattedPhoneNumber(phnNumber, iso2);
    const guestName = FireboardUtils.getGuestName(selectedItem);
    const pickupDate = FireboardUtils.getTimeInHrsMins(FireboardUtils.getPickupDate(selectedItem));
    setCheckInfo({
      ...checkInfo,
      isTextToPay,
      phoneNumber,
      guestName,
      pickupDate,
    });
  }, [selectedItem]);

  return (
    <>
      <PopupHeader
        title={'Payment History'}
        onClose={onClose}
        containerStyle={styles.heading}
        closeIconStyle={styles.headingTxt}
        titleStyle={styles.headingTxt} />
      <div className={styles.container}>
        {filteredTickets && filteredTickets.length
          ? tickets.map(ticket =>
            <div key={ticket.id} className={styles.wrapper}>
              <Content label={'Method:'} value={ticket.ticketPaymentTypeId === 1 ? ticket.vendorName : strings.cash} />
              <Content label={'Total:'} value={`${currency}${getTotal(ticket)}`} rightAlign />
              <Content label={'Card Type:'} value={ticket.cardType} />
              <Content label={'Tip:'} value={`${currency}${getTip(ticket)}`} rightAlign />
              <Content label={'Card #:'} value={ticket.redactedCardNumber} />
              <Content label={ticket.ticketTypeId === 2 ? 'Refund:' : 'Payment:'} value={`${currency}${getAmount(ticket)}`} rightAlign />
              <Content label={'Expiration:'} value={ticket.cardExpirationDate} />
              <Content
                label={ticket.ticketStatusId === TicketStatusType.ERROR ? 'Payment Status:' : ''}
                value={ticket.ticketStatusId === TicketStatusType.ERROR ? strings.paymentStatusError : ''}
                rightAlign
                hasError />
              {checkInfo.isTextToPay
                ? <>
                  <Content label={'Type:'} value={strings.callIn} />
                  <Content label={'Phone Number:'} value={checkInfo.phoneNumber} rightAlign />
                  <Content label={'Guest Name:'} value={checkInfo.guestName} />
                  <Content label={'Pickup Date:'} value={checkInfo.pickupDate} rightAlign />
                </>
                : null
              }
              {ticket?.message
                ? <Message label={'Message:'} value={ticket?.message} />
                : null
              }
              {selectedItem?.sourceType === 3
                ? null
                : <>
                  <div className={styles.buttonWrapper}>
                    <Button className={styles.btn} disabled={!ticket.enableRepostPos} onClick={() => rePostPayment && rePostPayment(ticket)}>
                      <span className={styles.btnTxt}>REPOST POS</span>
                    </Button>
                  </div>
                </>
              }
            </div>
          )
          : <div className={styles.noContentWrapper}><span className={styles.noContentTxt}>No payment tickets are available</span></div>
        }
      </div>
    </>
  );
};

const Content = ({ label, value, rightAlign = false, hasError = false }) => {
  return (
    <div className={styles.contentWrapper} style={{ justifyContent: rightAlign ? 'flex-end' : 'flex-start' }}>
      <span className={styles.txt}>{label}&nbsp;</span>
      <span className={styles.txt} style={{ color: hasError ? '#ad0028' : '#4A4A4A' }}>{value}</span>
    </div>
  );
};

const Message = ({ label, value, rightAlign = false }) => {
  return (
    <div className={styles.contentWrapper} style={{ justifyContent: rightAlign ? 'flex-end' : 'flex-start', flexBasis: '100%' }}>
      <span className={styles.txt}>{label}&nbsp;</span>
      <span className={styles.subText}>{value}</span>
    </div>
  );
};

export default RePostPayment;

RePostPayment.propTypes = {
  selectedItem: PropTypes.object,
  currency: PropTypes.string,
  onClose: PropTypes.func,
  iso2: PropTypes.string,
  rePostPayment: PropTypes.func,
};

RePostPayment.defaultProps = {
  selectedItem: {},
  onClose: () => { },
  rePostPayment: () => { },
};
